import React from "react"
import { PresetImage } from "../../library/Preset"
import Toolbar from "./Toolbar"
import ToolbarItem from "./ToolbarItem"

interface StickersToolbarProps {
  stickers: PresetImage[]
  handleSticker: (stickerImg: HTMLImageElement) => void
}

export default function StickersToolbar({ stickers, handleSticker }: StickersToolbarProps) {
  const drag = (e: React.DragEvent) => {
    e.dataTransfer.setData("sticker", (e.target as Element).id)
  }

  return (
    <Toolbar>
      {stickers.map((sticker, index) => (
        <ToolbarItem
          key={index}
          onClick={() => {}}
        >
          <img
            crossOrigin="anonymous"
            id={"sticker" + index}
            src={sticker.url}
            alt={"Sticker " + index}
            draggable="true"
            style={{ cursor: "grab" }}
            onDragStart={drag}
            onClick={(e: React.MouseEvent) => {
              const stickerCopy = (e.target as HTMLImageElement).cloneNode(true) as HTMLImageElement
              handleSticker(stickerCopy)
            }}
          />
        </ToolbarItem>
      ))}
    </Toolbar>
  )
}
